var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Dimmer, Form, Grid, Header, Loader, Message } from "semantic-ui-react";
import AddressEditForm from "../AddressForm";
import ErrorDisplay from "../ErrorDisplay";
import { postJsonWithAuthn } from "../RequestHelpers";
var EditAddressesModal = /** @class */ (function (_super) {
    __extends(EditAddressesModal, _super);
    function EditAddressesModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onUseShippingForBillingChange = function () {
            _this.setState(function (oldState) {
                return {
                    useShippingForBilling: !oldState.useShippingForBilling
                };
            }, function () {
                if (_this.state.useShippingForBilling) {
                    _this.setBillingAddressState(_this.state.shippingAddress);
                }
            });
        };
        _this.setShippingAddressState = function (s) {
            _this.setState(function (oldState) {
                return {
                    shippingAddress: Object.assign({}, oldState.shippingAddress, s)
                };
            });
        };
        _this.setBillingAddressState = function (s) {
            _this.setState(function (oldState) {
                return {
                    billingAddress: Object.assign({}, oldState.billingAddress, s)
                };
            });
        };
        _this.submitAddresses = function () {
            _this.setState({
                loading: true,
                success: false,
                errors: []
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/addresses", JSON.stringify({
                    shippingAddress: _this.state.shippingAddress,
                    billingAddress: _this.state.billingAddress,
                })).then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                }).then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false,
                            success: false
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            shippingAddress: props.initialShippingAddress,
            useShippingForBilling: false,
            billingAddress: props.initialBillingAddress
        };
        return _this;
    }
    EditAddressesModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Header, null, "Shipping Info"),
            React.createElement("div", { className: 'field-group' },
                React.createElement(Grid, { columns: 3 },
                    React.createElement(AddressEditForm, { address: this.state.shippingAddress, disabled: this.state.success, errorPathPrefix: '/shippingAddress', errors: this.state.errors, setAddressState: this.setShippingAddressState }))),
            React.createElement(Header, null, "Billing Info"),
            React.createElement(Checkbox, { disabled: this.state.success, label: 'Use Shipping Address', onChange: this.onUseShippingForBillingChange, checked: this.state.useShippingForBilling }),
            !this.state.useShippingForBilling &&
                React.createElement("div", { className: 'field-group' },
                    React.createElement(Grid, { columns: 3 },
                        React.createElement(AddressEditForm, { address: this.state.billingAddress, disabled: this.state.success, errorPathPrefix: '/billingAddress', errors: this.state.errors, setAddressState: this.setBillingAddressState }))),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Addresses saved."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement("div", null,
                React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.submitAddresses, positive: true })));
    };
    return EditAddressesModal;
}(React.PureComponent));
export default EditAddressesModal;
//# sourceMappingURL=EditOrderAddresses.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditOrderAddresses.js
// module id = 1257
// module chunks = 0